export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.8-1125.35",
  commitId: "daebe898b1c461c9fd706eda215bc55517614606",
  commitTime: "2026-04-08T11:25:35.000Z",
});
